import type { FeatureFlagKey } from '@risksmart-app/feature-flags/src/flags';
import {
  featureFlagKeys,
  featureFlagKeySchema,
} from '@risksmart-app/feature-flags/src/flags';

/**
 * Feature flags that are NOT module-backed. These are for in-progress work
 * and are evaluated through OpenFeature (flagd locally, Datadog in cloud
 * environments), with `REACT_APP_FEATURE_*` env vars as a local force-enable.
 *
 * For module-backed features, use module keys with `isModuleEnabled` instead.
 *
 * Re-exported from the OpenFeature registry (`@risksmart-app/feature-flags`),
 * the single source of truth for flag keys.
 */
export const featureFlags = featureFlagKeys;

export const featureFlagSchema = featureFlagKeySchema;
export type FeatureFlag = FeatureFlagKey;

export interface Module {
  enabled: boolean;
  config?: Record<string, unknown>;
  subModules?: Record<string, Module>;
  allowTabConfig?: boolean;
}

export type ModuleConfig = Record<string, Module>;

/**
 * Extracts all valid dot-notation module key paths from a module tree type.
 * E.g. 'risk' | 'risk.subModules.impact' | 'document.subModules.attestation' | ...
 */
export type ExtractModuleKeys<
  T extends Record<string, Module>,
  Prefix extends string = '',
> = {
  [K in keyof T & string]:
    | `${Prefix}${K}`
    | (T[K] extends {
        readonly subModules: infer S extends Record<string, Module>;
      }
        ? ExtractModuleKeys<S, `${Prefix}${K}.subModules.`>
        : never);
}[keyof T & string];
